<template>
  <!--<div class="ui form" >-->
    <!--<div class="field">-->
      <!--<label v-if="!options.hideLabel">{{label}}</label>-->
      <select class="ui dropdown" @input="setValue($event.target.value)" :value="getValue" :disabled="property.readOnly">
        <option v-for="(option,index) in property.enum" :value="option">{{option}}</option>
      </select>
    <!--</div>-->
  <!--</div>-->

</template>

<script>
    import singleControlMixin from './singleControlMixin'
    export default {
      name: "select-control",
      mixins: [singleControlMixin],
    }
</script>

<style scoped>

</style>
